if (!customElements.get('sticky-add-to-bag')) {
  customElements.define(
    'sticky-add-to-bag',
    class StickyAddToBag extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.priceTarget = this.querySelector('[data-sticky-price]');
        this.atcButton = this.querySelector('[data-sticky-atc]');
        this.imageEl = this.querySelector('.sticky-add-to-bag__image img');
        this.sourcePrice = document.querySelector(`#price-${this.sectionId} .price`);
        this.sourceSubmit = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        this.placement = 'hidden';
        this.placementBound = false;

        this.syncPrice();
        this.syncMedia();
        this.syncSubmitState();
        this.bindEvents();
        this.updatePlacement();
      }

      disconnectedCallback() {
        this.unbindPlacementEvents();
        this.priceObserver?.disconnect();
        this.variantUnsubscriber?.();
        this.mediaQuery?.removeEventListener('change', this.onBreakpointChange);
        this.atcButton?.removeEventListener('click', this.onStickyClick);
        this.syncChatLift(false);
      }

      isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      bindEvents() {
        this.onStickyClick = this.onStickyClick.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.atcButton?.addEventListener('click', this.onStickyClick);
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.mediaQuery.addEventListener('change', this.onBreakpointChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data?.sectionId !== this.sectionId) return;
            requestAnimationFrame(() => {
              this.sourcePrice = document.querySelector(`#price-${this.sectionId} .price`);
              this.sourceSubmit = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
              this.syncPrice();
              this.syncMedia();
              this.syncSubmitState();
              if (this.isMobile()) this.updatePlacement();
            });
          });
        }

        if (this.sourcePrice) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.sourcePrice, { childList: true, subtree: true, characterData: true });
        }

        this.bindPlacementEvents();
      }

      bindPlacementEvents() {
        if (this.placementBound || !this.isMobile()) return;
        this.placementBound = true;
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);

        if (this.sourceSubmit && typeof IntersectionObserver !== 'undefined') {
          this.observer = new IntersectionObserver(() => this.updatePlacement(), { threshold: 0 });
          this.observer.observe(this.sourceSubmit);
        }
      }

      unbindPlacementEvents() {
        if (!this.placementBound) {
          this.observer?.disconnect();
          return;
        }
        this.placementBound = false;
        this.observer?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      onBreakpointChange() {
        if (this.isMobile()) {
          this.bindPlacementEvents();
          this.updatePlacement();
          return;
        }
        this.unbindPlacementEvents();
        this.setPlacement('hidden');
      }

      onScroll() {
        if (!this.isMobile()) return;
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.updatePlacement();
        });
      }

      updatePlacement() {
        if (!this.isMobile() || !this.sourceSubmit) {
          this.setPlacement('hidden');
          return;
        }

        const rect = this.sourceSubmit.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 0;
        if (inView) {
          this.setPlacement('hidden');
          return;
        }

        this.setPlacement(rect.top >= window.innerHeight ? 'bottom' : 'top');
      }

      headerOffset() {
        const header = document.querySelector('.section-header');
        if (!header || header.classList.contains('shopify-section-header-hidden')) return 0;
        const bottom = header.getBoundingClientRect().bottom;
        return bottom > 0 ? Math.round(bottom) : 0;
      }

      setPlacement(placement) {
        if (!this.isMobile()) placement = 'hidden';
        const visible = placement !== 'hidden';
        this.placement = placement;
        this.classList.toggle('is-visible', visible);
        this.classList.toggle('is-top', placement === 'top');
        this.classList.toggle('is-bottom', placement === 'bottom');
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('sticky-atc-visible', placement === 'bottom');
        document.body.classList.toggle('sticky-atc-top', placement === 'top');

        if (placement === 'top') {
          this.style.top = `${this.headerOffset()}px`;
          this.style.bottom = 'auto';
        } else {
          this.style.top = '';
          this.style.bottom = '';
        }

        this.syncChatLift(placement === 'bottom');
      }

      /* Shopify Inbox bubble lives in shadow DOM; lift it above the bottom sticky bar. */
      syncChatLift(lift) {
        const apply = () => {
          const host = document.querySelector('shopify-chat');
          if (!host || !host.shadowRoot) return false;
          let style = host.shadowRoot.getElementById('molly-sticky-atc-chat');
          if (!style) {
            style = document.createElement('style');
            style.id = 'molly-sticky-atc-chat';
            host.shadowRoot.appendChild(style);
          }
          style.textContent = lift
            ? '.activator-nudge{bottom:calc(7.5rem + env(safe-area-inset-bottom, 0px) + 1.2rem)!important}'
            : '';
          return true;
        };

        if (apply()) return;
        window.clearTimeout(this.chatTimer);
        this.chatTimer = window.setTimeout(apply, 400);
      }

      onStickyClick(event) {
        event.preventDefault();
        if (!this.sourceSubmit || this.sourceSubmit.disabled) return;
        this.sourceSubmit.click();
      }

      isPriceRoll(el) {
        return !!(el && (el.classList.contains('price-roll') || el.querySelector('.price-roll__reel')));
      }

      extraOffPercent(wrap) {
        const btn = wrap && wrap.querySelector('.product-pdp-extra-off');
        const percent = parseInt(btn && btn.getAttribute('data-discount-percent'), 10);
        return isNaN(percent) ? 10 : percent;
      }

      formatFromCents(cents, sampleText) {
        if (cents === null || cents === undefined || isNaN(cents)) return '';
        const symbol = String(sampleText || '$').replace(/[\d.,\s-]/g, '').slice(0, 3) || '$';
        const value = Math.abs(Number(cents)) / 100;
        if (Number(cents) % 100 === 0) return symbol + String(Math.round(value));
        return symbol + value.toFixed(2);
      }

      parsePriceCents(el, attrName) {
        if (!el) return NaN;
        const attr = parseInt(el.getAttribute(attrName), 10);
        if (!isNaN(attr) && attr >= 0) return attr;
        if (this.isPriceRoll(el)) return NaN;
        const text = String(el.textContent || '').replace(/\s+/g, '');
        const numeric = text.replace(/[^\d.]/g, '');
        if (!numeric || numeric.replace('.', '').length > 8) return NaN;
        const value = parseFloat(numeric);
        if (isNaN(value)) return NaN;
        return Math.round(value * 100);
      }

      readSaleCents(el) {
        let cents = this.parsePriceCents(el, 'data-price-cents');
        if (isNaN(cents)) return NaN;
        const wrap = el.closest('.product-pdp-price');
        if (wrap && wrap.classList.contains('is-extra-off') && this.isPriceRoll(el)) {
          cents = Math.max(0, cents - Math.floor((cents * this.extraOffPercent(wrap)) / 100));
        }
        return cents;
      }

      readPriceText(el, attrName) {
        if (!el) return '';
        const sample = this.isPriceRoll(el)
          ? el.getAttribute('aria-label') || ''
          : String(el.textContent || '').trim();
        const cents =
          attrName === 'data-compare-cents' ? this.parsePriceCents(el, attrName) : this.readSaleCents(el);
        const formatted = this.formatFromCents(cents, sample);
        if (formatted) return formatted;
        if (this.isPriceRoll(el)) return this.lastSaleText || '';
        return '';
      }

      readOffPercent(saleEl, compareEl) {
        const notes = Array.from(this.sourcePrice.querySelectorAll('.price-item-off')).filter(
          (el) => getComputedStyle(el).display !== 'none'
        );
        for (let i = 0; i < notes.length; i++) {
          const match = String(notes[i].textContent || '').match(/(\d+)\s*%/);
          if (match) return parseInt(match[1], 10);
        }
        const saleCents = this.readSaleCents(saleEl);
        const compareCents = this.parsePriceCents(compareEl, 'data-compare-cents');
        if (isNaN(saleCents) || isNaN(compareCents) || compareCents <= saleCents) return 0;
        return Math.round(((compareCents - saleCents) / compareCents) * 100);
      }

      syncPrice() {
        if (!this.priceTarget) return;
        this.sourcePrice = document.querySelector(`#price-${this.sectionId} .price`);
        if (!this.sourcePrice) return;

        const sale =
          this.sourcePrice.querySelector('.price-item--sale') ||
          this.sourcePrice.querySelector('.price__regular .price-item--regular');
        const compare = this.sourcePrice.querySelector('.price__sale .price-item--regular');

        const saleText = this.readPriceText(sale, 'data-price-cents');
        if (saleText) this.lastSaleText = saleText;
        const displaySale = saleText || this.lastSaleText;
        const saleHtml = displaySale ? `<span class="sticky-add-to-bag__sale">${displaySale}</span>` : '';

        const offPercent = this.readOffPercent(sale, compare);
        const offHtml =
          offPercent > 0 ? `<span class="sticky-add-to-bag__off">(${offPercent}%off)</span>` : '';

        const compareText = this.readPriceText(compare, 'data-compare-cents');
        const compareHtml = compareText ? `<s class="sticky-add-to-bag__compare">${compareText}</s>` : '';

        this.priceTarget.innerHTML = `<span class="sticky-add-to-bag__price-row">${saleHtml}${offHtml}</span>${compareHtml}`;
      }

      syncMedia() {
        if (!this.imageEl) return;
        const active = document.querySelector(
          `#MainProduct-${this.sectionId} .product__media-item.is-active img, #MainProduct-${this.sectionId} media-gallery img`
        );
        if (!active) return;
        const nextSrc = active.currentSrc || active.src;
        if (nextSrc) this.imageEl.src = nextSrc;
        if (active.alt) this.imageEl.alt = active.alt;
      }

      syncSubmitState() {
        if (!this.atcButton || !this.sourceSubmit) return;
        const soldOut = this.sourceSubmit.disabled || this.sourceSubmit.classList.contains('is-sold-out');
        this.atcButton.disabled = soldOut;
        const label = this.sourceSubmit.querySelector('span:not(.loading__spinner)');
        const stickyLabel = this.querySelector('.sticky-add-to-bag__button-label');
        if (label && stickyLabel) stickyLabel.textContent = label.textContent.trim();
      }
    }
  );
}
